import React from 'react'

import StarYellow from '../../assets/starYellow.inline.svg'
import ReviewStars from '../reviews/reviewStars'

import stylesV2 from './reviewHighlightsSectionV2.module.scss'
export interface ReviewHighlightsSummaryProps {
  averageRating?: number
  reviewCount?: number
  showReviewSection: () => void
}

const ReviewHighlightsSummary = ({ averageRating, reviewCount, showReviewSection }: ReviewHighlightsSummaryProps) => {
  const finalStyles = stylesV2
  return (
    <div className={finalStyles.reviewHighlightDetails}>
      <ReviewStars
        totalStars={5}
        fillStars={averageRating ?? 0}
        starSvg={StarYellow}
        classNameIcon={finalStyles.reviewHighlightDetails__starIcon}
      />
      <span className={finalStyles.reviewHighlightDetails__averageRating}>{averageRating}</span>
      <span>{'('}</span>
      <span
        role="button"
        tabIndex={0}
        onClick={showReviewSection}
        className={finalStyles.reviewHighlightDetails__reviewCountLink}
      >
        {reviewCount}
      </span>
      <span>{')'}</span>
    </div>
  )
}

export default ReviewHighlightsSummary
